import { render, staticRenderFns } from "./invoice-preview.vue?vue&type=template&id=5a45fcb0&scoped=true"
import script from "./invoice-preview.vue?vue&type=script&lang=js"
export * from "./invoice-preview.vue?vue&type=script&lang=js"
import style0 from "./invoice-preview.vue?vue&type=style&index=0&id=5a45fcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45fcb0",
  null
  
)

export default component.exports